export default {
  name: "dashboard",
};
